export default {
  name: "dashboard",
};
